module.exports = __webpack_public_path__ + "school/img/applicationBg.971b5b48.jpg";